import type {
  PatientSupplement,
  PatientSupplementCreate,
  PatientSupplementFields,
} from "@/types/patient-supplement";

import { requestData } from "@/api/api-config";

export async function listPatientSupplements(
  patientId: string,
): Promise<PatientSupplement[] | null> {
  return await requestData<PatientSupplement[]>(
    `user/patient/supplements/patient/${patientId}`,
    "get",
  );
}

export async function listSupplementNames(): Promise<string[] | null> {
  return await requestData<string[]>("user/patient/supplements/names", "get");
}

export async function createPatientSupplement(
  supplement: PatientSupplementCreate,
): Promise<PatientSupplement | null> {
  return await requestData<PatientSupplement>(
    "user/patient/supplements",
    "post",
    { json: supplement },
    false,
  );
}

export async function updatePatientSupplement(
  supplementId: string,
  supplement: PatientSupplementFields,
): Promise<PatientSupplement | null> {
  return await requestData<PatientSupplement>(
    `user/patient/supplements/${supplementId}`,
    "patch",
    { json: supplement },
    false,
  );
}

export async function archivePatientSupplement(
  supplementId: string,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `user/patient/supplements/${supplementId}`,
    "delete",
    undefined,
    false,
  );
}
